import CustomAccording from "../../../customs/according"
import LinkSidebar from "../../../links/link_sidebar"

const SidebarMarket = () => {
    return (
        <>
            <LinkSidebar link="/dashboard" name="Dashboard" />
            <LinkSidebar link="/dashboard/unit" name="Unit / Kavling" />
            <LinkSidebar link="/dashboard/selling" name="Penjualan" />
            <LinkSidebar link="/dashboard/consument" name="Konsumen" />
        </>
    )
}

export default SidebarMarket

